import Vue from 'vue';
import router from '@/router';
import PositionService from '@/services/PositionService.js';
export const namespaced = true;
export const state = {
    positions: [], // OBS: inkluderar borttagna platser. Använd getter activePositions på ställen där vi inte vill ha med borttagna platser
    categories: [], // OBS: inkluderar borttagna kategorier, och kategorier som inte har några positions. Använd getter activeCategories på ställen där vi inte vill ha med borttagna kategorier
    lodgingTypes: [],
    fetchedAvailabilities: [],
    fetchingAvailabilities: [],
    availabilitiesErrors: [],
    fetchedCategoryAvailabilities: [],
    fetchingCategoryAvailabilities: [],
    categoryAvailabilitiesErrors: [],
    positionBlockDialog: {
        show: false,
        positionBlock: null,
        editingRecords: [],
        isFetching: false,
        isFetchingEditingRecords: false,
        isDeleting: false,
        closingDate: null,
        errorMessage: '',
        isEditMode: false,
        isSaving: false,
        openingDate: null,
        positionBlockId: null,
        positionIds: [],
        reason: ''
    },
    positionBlockForm: {
        show: false,
        positionBlockId: null,
        positionIds: [],
        closingDate: null,
        openingDate: null,
        reason: '',
        errorMessage: '',
        isSaving: false
    },
    mapPath: '',
    triggerPositionBlocksUpdated: 0
};
export const mutations = {
    SET_POSITIONS(state, val) {
        state.positions = val;
    },
    SET_CABIN_CLIMATE(state, val) {
        const position = state.positions.find(position => position.id === val.positionId);
        if (position) {
            Vue.set(position, 'cabin_climate', { ...position.cabin_climate, ...val.climate });
        }
    },
    SET_CATEGORIES(state, val) {
        state.categories = val;
    },
    SET_LODGING_TYPES(state, val) {
        state.lodgingTypes = val;
    },
    ADD_FETCHED_AVAILABILITY(state, val) {
        state.fetchedAvailabilities.push(val);
    },
    DELETE_FETCHED_AVAILABILITY(state, val) {
        const i = state.fetchedAvailabilities.findIndex(fetchedAvailability => {
            return fetchedAvailability.checkIn.isSame(val.checkIn, 'date') && fetchedAvailability.checkOut.isSame(val.checkOut, 'date') && fetchedAvailability.bookingId === val.bookingId && fetchedAvailability.occupancy === val.occupancy && fetchedAvailability.dogs === val.dogs;
        });
        if (i >= 0) {
            state.fetchedAvailabilities.splice(i, 1);
        }
    },
    ADD_FETCHING_AVAILABILITY(state, val) {
        state.fetchingAvailabilities.push(val);
    },
    DELETE_FETCHING_AVAILABILITY(state, val) {
        const i = state.fetchingAvailabilities.findIndex(fetchingAvailability => {
            return fetchingAvailability.checkIn.isSame(val.checkIn, 'date') && fetchingAvailability.checkOut.isSame(val.checkOut, 'date') && fetchingAvailability.bookingId === val.bookingId && fetchingAvailability.occupancy === val.occupancy && fetchingAvailability.dogs === val.dogs;
        });
        if (i >= 0) {
            state.fetchingAvailabilities.splice(i, 1);
        }
    },
    ADD_AVAILABILITY_ERROR(state, val) {
        state.availabilitiesErrors.push(val);
    },
    DELETE_AVAILABILITY_ERROR(state, val) {
        const i = state.availabilitiesErrors.findIndex(availabilityError => {
            return availabilityError.checkIn.isSame(val.checkIn, 'date') && availabilityError.checkOut.isSame(val.checkOut, 'date') && availabilityError.bookingId === val.bookingId && availabilityError.occupancy === val.occupancy && availabilityError.dogs === val.dogs;
        });
        if (i >= 0) {
            state.availabilitiesErrors.splice(i, 1);
        }
    },
    ADD_FETCHED_CATEGORY_AVAILABILITY(state, val) {
        state.fetchedCategoryAvailabilities.push(val);
    },
    DELETE_FETCHED_CATEGORY_AVAILABILITY(state, val) {
        const i = state.fetchedCategoryAvailabilities.findIndex(fetchedCategoryAvailability => {
            return fetchedCategoryAvailability.checkIn.isSame(val.checkIn, 'date') && fetchedCategoryAvailability.checkOut.isSame(val.checkOut, 'date') && fetchedCategoryAvailability.bookingId === val.bookingId && fetchedCategoryAvailability.occupancy === val.occupancy && fetchedCategoryAvailability.dogs === val.dogs;
        });
        if (i >= 0) {
            state.fetchedCategoryAvailabilities.splice(i, 1);
        }
    },
    ADD_FETCHING_CATEGORY_AVAILABILITY(state, val) {
        state.fetchingCategoryAvailabilities.push(val);
    },
    DELETE_FETCHING_CATEGORY_AVAILABILITY(state, val) {
        const i = state.fetchingCategoryAvailabilities.findIndex(fetchingCategoryAvailability => {
            return fetchingCategoryAvailability.checkIn.isSame(val.checkIn, 'date') && fetchingCategoryAvailability.checkOut.isSame(val.checkOut, 'date') && fetchingCategoryAvailability.bookingId === val.bookingId && fetchingCategoryAvailability.occupancy === val.occupancy && fetchingCategoryAvailability.dogs === val.dogs;
        });
        if (i >= 0) {
            state.fetchingCategoryAvailabilities.splice(i, 1);
        }
    },
    ADD_CATEGORY_AVAILABILITY_ERROR(state, val) {
        state.categoryAvailabilitiesErrors.push(val);
    },
    DELETE_CATEGORY_AVAILABILITY_ERROR(state, val) {
        const i = state.categoryAvailabilitiesErrors.findIndex(categoryAvailabilitiesError => {
            return categoryAvailabilitiesError.checkIn.isSame(val.checkIn, 'date') && categoryAvailabilitiesError.checkOut.isSame(val.checkOut, 'date') && categoryAvailabilitiesError.bookingId === val.bookingId && categoryAvailabilitiesError.occupancy === val.occupancy && categoryAvailabilitiesError.dogs === val.dogs;
        });
        if (i >= 0) {
            state.categoryAvailabilitiesErrors.splice(i, 1);
        }
    },
    UPDATE_POSITION_REMARKS(state, val) {
        const position = state.positions.find(pos => pos.id === val.positionId);
        if (!position) {
            return;
        }
        if (position.timestampLastPositionRemarkUpdate && val.timestamp < position.timestampLastPositionRemarkUpdate) {
            return false;
        }
        position.timestampLastPositionRemarkUpdate = val.timestamp;
        position.remarks = val.remarks;
    },
    // positionBlockDialog
    SET_POSITION_BLOCK_DIALOG_SHOW(state, val) {
        state.positionBlockDialog.show = val;
    },
    SET_POSITION_BLOCK_DIALOG_POSITION_BLOCK(state, val) {
        state.positionBlockDialog.positionBlock = val;
    },
    SET_POSITION_BLOCK_DIALOG_IS_FETCHING(state, val) {
        state.positionBlockDialog.isFetching = val;
    },
    SET_POSITION_BLOCK_DIALOG_EDITING_RECORDS(state, val) {
        state.positionBlockDialog.editingRecords = val;
    },
    SET_POSITION_BLOCK_DIALOG_IS_FETCHING_EDITING_RECORDS(state, val) {
        state.positionBlockDialog.isFetchingEditingRecords = val;
    },
    SET_POSITION_BLOCK_DIALOG_IS_DELETING(state, val) {
        state.positionBlockDialog.isDeleting = val;
    },
    // positionBlockForm
    SET_POSITION_BLOCK_FORM_SHOW(state, val) {
        state.positionBlockForm.show = val;
    },
    SET_POSITION_BLOCK_FORM_ID(state, val) {
        state.positionBlockForm.positionBlockId = val;
    },
    SET_POSITION_BLOCK_FORM_POSITION_IDS(state, val) {
        state.positionBlockForm.positionIds = val;
    },
    SET_POSITION_BLOCK_FORM_CLOSING_DATE(state, val) {
        state.positionBlockForm.closingDate = val;
    },
    SET_POSITION_BLOCK_FORM_OPENING_DATE(state, val) {
        state.positionBlockForm.openingDate = val;
    },
    SET_POSITION_BLOCK_FORM_REASON(state, val) {
        state.positionBlockForm.reason = val;
    },
    SET_POSITION_BLOCK_FORM_ERROR_MESSAGE(state, val) {
        state.positionBlockForm.errorMessage = val;
    },
    SET_POSITION_BLOCK_FORM_IS_SAVING(state, val) {
        state.positionBlockForm.isSaving = val;
    },
    SET_MAP_PATH(state, val) {
        state.mapPath = val;
    },
    TRIGGER_POSITION_BLOCKS_UPDATED(state) {
        state.triggerPositionBlocksUpdated++;
    }
};
export const actions = {
    fetchPositions({ commit }) {
        return PositionService.getPositions()
            .then(({ data }) => {
            commit('SET_POSITIONS', data.data.positions);
        })
            .finally(() => {
            window.channel.stopListening('PositionRemarksUpdated').listen('PositionRemarksUpdated', function (data) {
                commit('UPDATE_POSITION_REMARKS', { positionId: data.position_id, remarks: data.remarks, timestamp: data.timestamp });
            });
        });
    },
    enrichPositions({ state }) {
        return new Promise((resolve, reject) => {
            window.enrich.enrichPosition(state.positions);
            resolve(true);
        });
    },
    fetchCategories({ commit }) {
        return PositionService.getCategories()
            .then(({ data }) => {
            commit('SET_CATEGORIES', data.data.categories);
        });
    },
    fetchCategoriesAndPositions({ commit }) {
        return PositionService.getCategoriesAndPositions()
            .then(({ data }) => {
            commit('SET_POSITIONS', data.data.positions);
            commit('SET_CATEGORIES', data.data.categories);
        })
            .finally(() => {
            window.channel.stopListening('PositionRemarksUpdated').listen('PositionRemarksUpdated', function (data) {
                commit('UPDATE_POSITION_REMARKS', { positionId: data.position_id, remarks: data.remarks, timestamp: data.timestamp });
            });
        });
    },
    fetchMap({ rootState, commit, rootGetters }) {
        const mapPath = `https://assets.campingonline.se/client/${rootGetters['user/activeAuthSession'].user.namespace}/map.png`;
        const backupPath = 'https://assets.campingonline.se/client/default/map.png';
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                commit('SET_MAP_PATH', mapPath);
                resolve();
            };
            img.onerror = () => {
                commit('SET_MAP_PATH', backupPath);
                resolve();
            };
            img.src = mapPath;
        });
    },
    enrichCategories({ state }) {
        return new Promise((resolve, reject) => {
            window.enrich.enrichCategory(state.categories);
            resolve(true);
        });
    },
    fetchAvailability({ state, commit }, { checkIn, checkOut, bookingId, occupancy, dogs }) {
        let availability = state.fetchedAvailabilities.find(fetchedAvailability => {
            return fetchedAvailability.checkIn.isSame(checkIn, 'date') && fetchedAvailability.checkOut.isSame(checkOut, 'date') && fetchedAvailability.bookingId === bookingId && fetchedAvailability.occupancy === occupancy && fetchedAvailability.dogs === dogs;
        });
        if (availability && availability.fetchedAt.isAfter(window.dayjs.now().subtract(5, 'seconds'))) {
            return false;
        }
        availability = state.fetchingAvailabilities.find(fetchingAvailability => {
            return fetchingAvailability.checkIn.isSame(checkIn, 'date') && fetchingAvailability.checkOut.isSame(checkOut, 'date') && fetchingAvailability.bookingId === bookingId && fetchingAvailability.occupancy === occupancy && fetchingAvailability.dogs === dogs;
        });
        if (availability) {
            return false;
        }
        commit('DELETE_FETCHED_AVAILABILITY', { checkIn, checkOut, bookingId, occupancy, dogs });
        commit('DELETE_AVAILABILITY_ERROR', { checkIn, checkOut, bookingId, occupancy, dogs });
        commit('ADD_FETCHING_AVAILABILITY', { sentAt: window.dayjs.now(), checkIn, checkOut, bookingId, occupancy, dogs });
        PositionService.getAvailabilities({ checkIn, checkOut, bookingId, occupancy, dogs })
            .then(({ data }) => {
            commit('ADD_FETCHED_AVAILABILITY', {
                fetchedAt: window.dayjs.now(),
                checkIn,
                checkOut,
                bookingId,
                occupancy,
                dogs,
                data: data.data.positions
            });
        })
            .catch(() => {
            commit('ADD_AVAILABILITY_ERROR', { fetchedAt: window.dayjs.now(), checkIn, checkOut, bookingId, occupancy, dogs });
        })
            .finally(() => {
            commit('DELETE_FETCHING_AVAILABILITY', { checkIn, checkOut, bookingId, occupancy, dogs });
        });
    },
    fetchCategoryAvailability({ state, commit }, { checkIn, checkOut, bookingId, occupancy, dogs }) {
        const fetchedAvailability = state.fetchedCategoryAvailabilities.find(fetchedCategoryAvailability => {
            return fetchedCategoryAvailability.checkIn.isSame(checkIn, 'date') && fetchedCategoryAvailability.checkOut.isSame(checkOut, 'date') && fetchedCategoryAvailability.bookingId === bookingId && fetchedCategoryAvailability.occupancy === occupancy && fetchedCategoryAvailability.dogs === dogs;
        });
        if (fetchedAvailability && fetchedAvailability.fetchedAt.isAfter(window.dayjs.now().subtract(5, 'seconds'))) {
            return false;
        }
        const fetchingAvailability = state.fetchingCategoryAvailabilities.find(fetchingCategoryAvailability => {
            return fetchingCategoryAvailability.checkIn.isSame(checkIn, 'date') && fetchingCategoryAvailability.checkOut.isSame(checkOut, 'date') && fetchingCategoryAvailability.bookingId === bookingId && fetchingCategoryAvailability.occupancy === occupancy && fetchingCategoryAvailability.dogs === dogs;
        });
        if (fetchingAvailability) {
            return false; // Hämtar redan
        }
        commit('DELETE_FETCHED_CATEGORY_AVAILABILITY', { checkIn, checkOut, bookingId, occupancy, dogs });
        commit('DELETE_CATEGORY_AVAILABILITY_ERROR', { checkIn, checkOut, bookingId, occupancy, dogs });
        commit('ADD_FETCHING_CATEGORY_AVAILABILITY', { sentAt: window.dayjs.now(), checkIn, checkOut, bookingId, occupancy, dogs });
        PositionService.getCategoryAvailabilities({
            checkIn,
            checkOut,
            bookingId,
            occupancy,
            dogs
        })
            .then(({ data }) => {
            commit('ADD_FETCHED_CATEGORY_AVAILABILITY', { fetchedAt: window.dayjs.now(), checkIn, checkOut, bookingId, occupancy, dogs, data: data.data.categories });
        })
            .catch(() => {
            commit('ADD_CATEGORY_AVAILABILITY_ERROR', { fetchedAt: window.dayjs.now(), checkIn, checkOut, bookingId, occupancy, dogs });
        })
            .finally(() => {
            commit('DELETE_FETCHING_CATEGORY_AVAILABILITY', { checkIn, checkOut, bookingId, occupancy, dogs });
        });
    },
    gotoPosition({ commit }, position) {
        // Använd för att gå till kartsidan, och välja och zooma in på en specifik plats
        router.push({ name: 'Map', params: { positionId: position.id } });
    },
    openPositionBlockDialog({ commit }, { positionBlock = null, positionBlockId = null }) {
        // Fungerar att använda antingen positionBlock object direkt, eller positionBlockId för att hämta objekt från server först
        if (positionBlock) {
            commit('SET_POSITION_BLOCK_DIALOG_IS_FETCHING', false);
            commit('SET_POSITION_BLOCK_DIALOG_POSITION_BLOCK', positionBlock);
        }
        else {
            commit('SET_POSITION_BLOCK_DIALOG_IS_FETCHING', true);
            PositionService.getPositionBlock({ positionBlockId })
                .then(({ data }) => {
                if (data.status === 'success') {
                    window.enrich.enrichPositionBlock(data.data.position_block);
                    commit('SET_POSITION_BLOCK_DIALOG_POSITION_BLOCK', data.data.position_block);
                }
            })
                .finally(() => {
                commit('SET_POSITION_BLOCK_DIALOG_IS_FETCHING', false);
            });
        }
        const resolvedPositionBlockId = positionBlock?.id ?? positionBlockId;
        commit('SET_POSITION_BLOCK_DIALOG_EDITING_RECORDS', []);
        commit('SET_POSITION_BLOCK_DIALOG_IS_FETCHING_EDITING_RECORDS', true);
        PositionService.getPositionBlockEditingRecords({ positionBlockId: resolvedPositionBlockId })
            .then(({ data }) => {
            if (data.status === 'success') {
                commit('SET_POSITION_BLOCK_DIALOG_EDITING_RECORDS', data.data.editing_records);
            }
        })
            .finally(() => {
            commit('SET_POSITION_BLOCK_DIALOG_IS_FETCHING_EDITING_RECORDS', false);
        });
        commit('SET_POSITION_BLOCK_DIALOG_SHOW', true);
    },
    startNewPositionBlock({ commit }, { positions, closingDate, openingDate }) {
        closingDate = closingDate ?? window.dayjs.today();
        openingDate = openingDate ?? window.dayjs.tomorrow();
        const positionIds = positions.map(pos => pos.id);
        commit('SET_POSITION_BLOCK_FORM_ID', 0);
        commit('SET_POSITION_BLOCK_FORM_POSITION_IDS', positionIds);
        commit('SET_POSITION_BLOCK_FORM_CLOSING_DATE', closingDate);
        commit('SET_POSITION_BLOCK_FORM_OPENING_DATE', openingDate);
        commit('SET_POSITION_BLOCK_FORM_REASON', '');
        commit('SET_POSITION_BLOCK_FORM_ERROR_MESSAGE', '');
        commit('SET_POSITION_BLOCK_FORM_IS_SAVING', false);
        commit('SET_POSITION_BLOCK_FORM_SHOW', true);
    },
    startEditPositionBlock({ commit }, { positionBlock }) {
        commit('SET_POSITION_BLOCK_FORM_ID', positionBlock.id);
        const positionIds = [positionBlock.position_id];
        commit('SET_POSITION_BLOCK_FORM_POSITION_IDS', positionIds);
        commit('SET_POSITION_BLOCK_FORM_CLOSING_DATE', positionBlock.closing_date.clone());
        commit('SET_POSITION_BLOCK_FORM_OPENING_DATE', positionBlock.opening_date.clone());
        commit('SET_POSITION_BLOCK_FORM_REASON', positionBlock.reason);
        commit('SET_POSITION_BLOCK_FORM_ERROR_MESSAGE', '');
        commit('SET_POSITION_BLOCK_FORM_IS_SAVING', false);
        commit('SET_POSITION_BLOCK_FORM_SHOW', true);
    },
    savePositionBlocks({ commit }, { positionBlockId, positionIds, closingDate, openingDate, reason }) {
        commit('SET_POSITION_BLOCK_FORM_IS_SAVING', true);
        PositionService.savePositionBlocks({ positionBlockId, positionIds, closingDate, openingDate, reason })
            .then(({ data }) => {
            if (data.status === 'success') {
                // TODO: felhantering, vissa platser kan ha sparats och andra inte (server returnerar isåfall closed_position_names och unclosed_position_names). Bedömer att det inte är så brådskande för användaren kan se normalt se i kalendern vad som händer.
                commit('TRIGGER_POSITION_BLOCKS_UPDATED');
            }
        })
            .finally(() => {
            commit('SET_POSITION_BLOCK_FORM_IS_SAVING', false);
        });
    },
    deletePositionBlock({ commit }, { positionBlock }) {
        commit('SET_POSITION_BLOCK_DIALOG_IS_DELETING', true);
        PositionService.deletePositionBlock({ positionBlock })
            .then(({ data }) => {
            if (data.status === 'success') {
                // snackbar skickas från server
                commit('TRIGGER_POSITION_BLOCKS_UPDATED');
            }
        })
            .finally(() => {
            commit('SET_POSITION_BLOCK_DIALOG_IS_DELETING', false);
        });
    }
};
export const getters = {
    activePositions: function (state) {
        if (state.positions.length === 0) {
            return [];
        }
        const positions = state.positions.filter(position => {
            return position.deleted_at === null;
        });
        return positions;
    },
    activeCategories: function (state) {
        // categories som inte är bortplockade och som har positions (som inte är bortplockade)
        if (state.categories.length === 0) {
            return [];
        }
        const categories = state.categories.filter(category => {
            return category.deleted_at === null && category.positions && category.positions.filter(pos => pos.deleted_at === null).length > 0;
        });
        return categories;
    },
    defaultBookingCategory: function (state, getters) {
        if (getters.activeCategories.length === 0) {
            return null;
        }
        return getters.activeCategories[0];
    },
    activeLodgingTypes: function (state, getters) {
        // lodgingTypes som används av aktiva categories
        if (getters.activeCategories.length === 0 || state.lodgingTypes.length === 0) {
            return [];
        }
        // @ts-ignore
        const allCategoryLodgingTypes = getters.activeCategories.flatMap(cat => cat.lodgingTypes);
        // @ts-ignore
        const uniqueCategoryLodgingTypes = allCategoryLodgingTypes.filter((lodgingType, i, self) => {
            // @ts-ignore
            return self.findIndex(x => x.id === lodgingType.id) === i;
        });
        return uniqueCategoryLodgingTypes;
    }
};
